import { Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Directive({
  selector: '[appCrossClose]',
  standalone: true,
  host: {
    '[style.position]': '"absolute"',
    '[style.top]': '"16px"',
    '[style.right]': '"16px"',
    '[style.z-index]': '"10"',
    '(click)': 'closeDialog()',
  },
})
export class CrossCloseDirective implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly dialogRef = inject(MatDialogRef, { optional: true });

  ngOnInit(): void {
    const button = this.elementRef.nativeElement;

    const matIcon = this.renderer.createElement('mat-icon');
    this.renderer.addClass(matIcon, 'mat-icon');
    this.renderer.addClass(matIcon, 'notranslate');
    this.renderer.addClass(matIcon, 'material-icons');
    this.renderer.addClass(matIcon, 'mat-ligature-font');

    const iconText = this.renderer.createText('close');
    this.renderer.appendChild(matIcon, iconText);
    this.renderer.appendChild(button, matIcon);

    this.renderer.setStyle(button, 'outline', 'none');
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
